import { createContentType, fetchContentTypes, deleteContentType, getContentType, editContentType } from '../api/api';
import { getSpecificWorkspace } from './workspaceAction';

export const UPDATE_STEP_DATA = 'UPDATE_STEP_DATA';
export const RESET_FORM = 'RESET_FORM';


export const addField = (fieldData) => ({
  type: 'ADD_FIELD',
  payload: fieldData,
});

export const updateField = (index, fieldData) => ({
  type: 'UPDATE_CONTENT_FIELD',
  payload: { index, fieldData }
});

export const removeField = (index) => ({
  type: "REMOVE_FIELD",
  payload: index,
});

export const resetForm = () => ({
  type: RESET_FORM,
});


export const submitFormData = (contentData) => async (dispatch) => {
  try {
    const res = await createContentType(contentData);
    dispatch({
      type: 'INITIATE_CONTENT_TYPE',
      payload: res.data
    })
    
    return res?.data
  } catch (error) {
    console.error('Failed to submit form:', error);
  }
}

export const getContentTypes = (workspaceId) => async (dispatch) => {
  try {
    const res = await fetchContentTypes(workspaceId);

    dispatch({
      type: 'GET_CONTENT_TYPES',
      payload: res.data
    });

  } catch (err) {
    console.log(err)
  }
}

export const deleteContent = (id) => async (dispatch) => {
  try {
    const res = await deleteContentType(id);

    dispatch({
      type: 'DELETE_CONTENT_TYPE',
      payload: id
    })

  } catch (err) {
    console.log(err)
  }
}

export const getContentTypeById = (workspaceId, id) => async (dispatch) => {
  try {
    const res = await getContentType(workspaceId, id);
    dispatch({
      type: 'GET_CONTENT',
      payload: res.data
    });

  } catch (err) {
    console.log(err)

  }
}

export const updateContentType = (id, contentData) => async (dispatch) => {
  try {
    const res = await editContentType(id, contentData);
    dispatch({
      type: 'UPDATE_CONTENT_TYPE',
        payload: res.data
    })
    console.log("content model updated.")

  } catch (error) {

    console.error('Failed to submit form:', error);

  }
}